import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {AlertController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../models/document.model';
import {ProductMultiSelectComponent} from '../modals/product-multi-select/product-multi-select.component';
import {EquipmentMultiSelectComponent} from '../modals/equipment-multi-select/equipment-multi-select.component';
import {EquipmentSelect} from '../modals/equipment-select/equipment-select';
import {EditPlantItemModalComponent} from '../modals/edit-plant-item-modal/edit-plant-item-modal.component';

@Injectable({
    providedIn: 'root'
})
export class EditProdQtyService {

    constructor(private alertController: AlertController,
                private modalController: ModalController) {
    }

    async editLine(item: DetaillineDTOModel, document: DocumentModel) {
        // Edit item will set the modal to edit the item.
        const modal = await this.modalController.create({
            component: EditPlantItemModalComponent,
            cssClass: 'auto-height',
            componentProps: {
                equipment: item,
                document: document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
            }
        });

        return await modal.present();
    }

    async editProdQty(item: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Edit Product',
            message: 'Please adjust the quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'itemQty',
                    type: 'number',
                    value: item.qty,
                    placeholder: 'Enter new Qty'
                },
                {
                    name: 'itemDescription',
                    type: 'text',
                    value: item.comment,
                    placeholder: 'Enter new Description'
                },
                {
                    name: 'itemPrice',
                    type: 'number',
                    value: item.total,
                    placeholder: 'Enter new Price'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                },
                {
                    text: 'Ok',
                    handler: data => {
                        item.qty = data.itemQty > 0 ? data.itemQty : 1;
                        item.weeklyRate = data.itemPrice;
                        item.total = data.itemPrice;
                        item.discount = 0;
                        item.comment = data.itemDescription;
                    }
                }
            ]
        });

        await alert.present();
    }
}
